export const ALT_EMAIL_ORIGINAL = 'ALT_EMAIL_ORIGINAL'
export const ALT_EMAIL_OTHER_USER = 'ALT_EMAIL_OTHER_USER'
export const ALT_EMAIL_TENANT = 'ALT_EMAIL_TENANT'
